export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const RESET_DEPARTMENT = 'RESET_DEPARTMENT';
export const SET_DEPARTMENTS = 'SET_DEPARTMENTS';
